import React from "react";
import NewContract from "./NewContract";

const DraftsContract = () => {
  return <div>NewContract</div>;
};

export default DraftsContract;
